import { motion } from "framer-motion";
import { BEFORE_AFTER } from "@/data/content";

export default function BeforeAfter() {
  return (
    <section
      data-testid="before-after"
      className="py-20 sm:py-28 lg:py-36 px-5 sm:px-6 lg:px-12 border-y border-neutral-200/70 bg-[#FAFAFA]"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-10 sm:mb-16">
          <div className="md:col-span-6">
            <p className="overline">Before / after</p>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] mt-5 sm:mt-6">
              Real businesses,
              <br />
              <span className="italic text-aurora">honest changes.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-base sm:text-lg text-neutral-700 leading-relaxed">
              We don&apos;t publish invented dollar figures. Each card below shows
              the qualitative shift we delivered. Real numbers - and what
              they cost - happily shared on a discovery call.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {BEFORE_AFTER.map((c, i) => (
            <motion.article
              key={c.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={`before-after-${c.id}`}
              className="border border-neutral-200 bg-white/70 backdrop-blur-sm p-6 sm:p-8 flex flex-col"
            >
              <p className="overline">{c.sector}</p>
              <h3 className="font-serif text-2xl sm:text-3xl tracking-tight leading-tight mt-3 sm:mt-4">
                {c.title}
              </h3>

              <div className="mt-6 sm:mt-8 border-t border-neutral-200 pt-5">
                <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-500 mb-2">Before</p>
                <p className="text-sm text-neutral-700 leading-relaxed">{c.before}</p>
              </div>
              <div className="mt-5 border-t border-gold/20 pt-5">
                <p className="text-[10px] uppercase tracking-[0.22em] text-gold mb-2">After · GoldKey Studio</p>
                <p className="text-sm text-neutral-900 leading-relaxed">{c.after}</p>
              </div>

              <p className="text-[11px] text-neutral-400 italic mt-6 leading-relaxed">
                {c.note}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
